import { ConsolidationRuleDefinitionDTO } from "../DTO/consolidationRuleDefinitionDTO";

export class ConsolidationRuleDefinition{
    public id!: number;
    public name!: string;
    public description!: string;
    public ruleType!: string;
    public inputDataType!: string;
    public parameterCount!: number;
    public parameterLabels!: string;

    public static mapFromDTO(param:ConsolidationRuleDefinitionDTO):ConsolidationRuleDefinition{ 
        if (!param) throw new Error("parameter is null")
        let obj = new ConsolidationRuleDefinition();
        try
        {
            obj.id = param.id;
            obj.name = param.name;
            obj.description = param.description;
            obj.ruleType = param.ruleType;
            obj.inputDataType = param.inputDataType;
            obj.parameterCount = param.parameterCount;
            obj.parameterLabels = param.parameterLabels;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:ConsolidationRuleDefinition):ConsolidationRuleDefinitionDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new ConsolidationRuleDefinitionDTO();
        try
        {
            dto.id = param.id;
            dto.name = param.name;
            dto.description = param.description;
            dto.ruleType = param.ruleType;
            dto.inputDataType = param.inputDataType;
            dto.parameterLabels = param.parameterLabels;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

    public getParameterLabel(index:number):{label:string, maxLength:number} | undefined {
        if(this.parameterLabels){
            let labelArray = this.parameterLabels.split(',');
            if(index < labelArray.length){
                let labelItemArray=labelArray[index].split(':');
                let maxLength= (labelItemArray.length>1)?labelItemArray[1]:50;
                return {label:labelItemArray[0], maxLength:isNaN(Number(maxLength))?50:Number(maxLength)}; //our default maxLength for Parameters is 50
            }
            else return undefined;
        }
        else return undefined;
    }
}